// what autentication mode to use when
// communicating with the identity server
export enum AuthMode {
  Callback,
  SilentRenew
}

// result of the login request
export enum LoginResult {
  Success,
  Error,
  Expired,
  Forbidden
}

// models the logged in user
export interface User {
  LogoutToken: string;
  AccessToken: string;
  errored: boolean;
  UserCode: string;
}

// models the initial state of the user
export function GenerateUndefinedUser(): User {
  return {
    LogoutToken: "",
    AccessToken: "",
    UserCode: "",
    errored: false
  };
}
